import * as React from 'react';
import { isNil } from 'lodash';

import { ModalFrameFooter, ModalFrameInner, ModalFrameMessage } from 'components/modal';

type Props = {
  body: {
    main: string,
    sub?: string,
    subConfirmation?: string
  },
  minHeight: number,
  actions: Array<any>
};

class ShippingStepMessage extends React.PureComponent<Props> {
  render(): React.ReactNode {
    const { body, actions, minHeight } = this.props;

    return (
      <React.Fragment>
        <ModalFrameInner
          minHeight={minHeight}
          verticalAlign="center"
        >
          <ModalFrameMessage
            message={body.main}
          />
          {
            !isNil(body.sub) &&
              <ModalFrameMessage
                message={body.sub}
              />
          }
          {
            !isNil(body.subConfirmation) &&
              <ModalFrameMessage
                message={body.subConfirmation}
              />
          }
        </ModalFrameInner>
        <ModalFrameFooter>
          {actions}
        </ModalFrameFooter>
      </React.Fragment>
    );
  }
}

export default ShippingStepMessage;
